export function SET_SAMPLE_SELECTED(state, sample) {
  state.sample_selected = sample;
}

export function SET_SAMPLES(state, samples) {
  state.samples = samples;
}

export function SET_AREA_SELECTED_SAMPLE(state, area) {
  state.area_selected = area;
}

export function SET_AREAS(state, areas) {
  state.soilAreas = areas;
}

export function SET_SHOW_ALL(state, value) {
  state.isShowAll = value;
}

export function SET_DATA_GUIDE(state, data) {
  state.samplesGuide = data.samplesGuide;
  state.kitType = data.kitType;
}

export function PUSH_SAMPLING_POINT(state, point) {
  state.samplingPoints.push(point)
}

export function REMOVE_SAMPLING_POINT(state, point) {
  state.samplingPoints = state.samplingPoints.filter(element => element.getData().id != point.getData().id)
}

export function SET_SAMPLING_POINTS(state, points) {
  state.samplingPoints = points
}
